import React from 'react';
import ClientForm from '../ClientForm/ClientForm';

const CreateClient = () => {
  return <ClientForm />
};

export default CreateClient;
